const solutionList = [



    {
        title: "企业级车间智能化服务",
        index: 4,
        showImg: "/static/img/solution/4.jpg",
        img: [
            '12.png',
            '13.png',
            '14.png',
            '15.png',
        ],
        class: "item-a",
        info: [

            `
            <p class="tit">人员全流程智能管理</p> 
            <p>● 通过智能传感器和管理软件，实时监控和管理车间人员的活动和工作状态 </p> 
            <p>● 提升人员管理效率，减少人为错误，优化人员调配，提高生产效率。<p>
           
            `,
            `
            <p class="tit"> 装备智能化分析</p> 
            <p>● 利用物联网传感器和AI算法，对车间设备的运行状态进行实时监控和数据分析。</p> 
            <p>● 预防设备故障，延长设备寿命，减少维护成本，提高生产设备的利用率。</p> 
            `,
            `
            <p class="tit"> 能源智能优化</p> 
            <p>● 通过智能化系统监控车间的能源使用情况，并提供优化方案。</p> 
            <p>● 降低能源消耗，减少碳排放，降低生产成本，提升企业绿色形象。</p> 
            `,
            `
            <p class="tit"> 人员行为操作智能分析</p> 
            <p>● 采用AI算法分析人员的操作行为，确保操作规范和安全。</p> 
            <p>● 提高操作安全性，减少事故发生，提高工作效率和质量。</p> 
            `,
        ],

    },
    {
        title: "企业级实验室智能化服务",
        class: "item-b",
        img: [
            '16.png',
            '17.png',
            '18.png',
            '19.png',
        ],
        index: 5,
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class="tit"> 实验过程电子记录</p> 
            <p>● 利用电子实验记录系统，实时记录实验过程中的每一个步骤和数据。</p> 
            <p>● 提高数据的准确性和完整性，减少纸质记录的错误和丢失，方便数据的存储和查找。</p> 
           
            `,
            `
           
            <p class="tit">数据真实性</p> 
            <p>● 通过区块链和加密技术，确保实验数据的真实性和不可篡改。</p> 
            <p>● 防止数据造假，确保数据可信度，满足监管和审计要求。</p> 
            `,
            `
            <p class="tit">实验全过程可追溯</p> 
            <p>● 实现实验全过程的数字化追踪，从实验设计到结果分析，每一步都有详细记录。</p> 
            <p>● 提高实验透明度，便于问题追溯和责任划分，提升实验管理水平。</p> 
           
            `,
            `
            <p class="tit">审计合规与统计分析</p> 
            <p>● 提供实验数据的审计和合规性检查，并进行统计分析。</p> 
            <p>● 确保实验合规性，满足监管要求，提供有价值的统计数据支持决策。</p> 
            `,
        ],
    },
    {
        title: "科研级实验室智能化服务",
        index: 6,
        class: "item-c",
        img: [
            '21.png',
            '22.png',
            '23.png',
            '24.png',
        ],
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class="tit"> 实验过程电子记录</p> 
            <p>● 同企业级实验室智能化服务，通过电子系统记录实验过程。</p> 
            <p>● 提升科研记录的准确性和效率，方便数据分享和协作。</p> 
           
            `,
            `
           
            <p class="tit">实验项目管理</p> 
            <p>● 提供实验项目的管理工具，从项目立项到结题的全过程管理。</p> 
            <p>● 提高科研项目管理效率，确保项目按计划进行，便于资源调配。</p> 
           
            `,
            `
            <p class="tit">数据真实性与流程可追溯</p> 
            <p>● 同企业级实验室服务，通过技术手段确保数据真实性和流程可追溯。</p> 
            <p>● 确保科研数据的可信度，提高科研透明度和公信力。</p> 
           
            `,
            `
           
            <p class="tit">数据集管理与智能算法自动训练</p> 
            <p>● 管理实验数据集，并利用智能算法进行自动分析和模型训练。</p> 
            <p>● 提升科研数据的利用效率，支持自动化分析，提高科研创新能力。</p> 
            `,
        ],
    },
    {
        title: "医疗实验室智能化服务",
        index: 7,
        img: [
            '25.png',
            '26.png',
            '27.png',
            '28.png',
        ],
        class: "item-d",
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class="tit"> 患者样本智能管理</p> 
            <p> ● 利用物联网和智能识别技术，对患者样本进行自动化管理和跟踪。</p> 
            <p> ● 提高样本管理效率，减少样本丢失和混淆，确保检验结果的准确性。</p> 
          
            `,
            `
            <p class="tit"> 实验数据实时监控</p> 
            <p> ● 通过智能系统实时监控实验数据，确保数据的准确性和及时性。</p> 
            <p> ● 提高数据处理效率，减少误差，确保实验结果可靠。</p> 
            `,
            `
            <p class="tit">  检测过程智能化分析</p> 
            <p>  ● 利用AI算法对检测过程进行智能分析，提供实时反馈和优化建议。</p> 
            <p>  ● 提高检测效率和准确性，减少人为干预，优化检测流程。</p> 
            `,
            `
            <p class="tit">  合规性和安全性保障</p> 
            <p>  ● 通过智能系统确保实验过程符合行业标准和法规，保障数据安全。</p> 
            <p> ● 提高合规性，确保数据安全，减少违规风险，提升实验室公信力。</p> 
            `,
        ],
    },
    {
        title: "公共服务平台智能化服务",
        index: 8,
        class: "item-e",
        img: [
            '29.png',
            '30.png',
            '31.png',
            '32.png',
        ],
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class="tit">  人员管理</p>
            <p>  ● 提供人员信息的管理和调度功能，实时监控和优化人员配置。</p>
            <p>  ● 提高人员管理效率，优化资源利用，确保服务质量。</p>
            `,

            `
            <p class="tit">  设备管理</p>
            <p>  ● 实时监控设备状态，提供设备维护和管理工具。</p>
            <p>  ● 延长设备寿命，减少设备故障，提高设备利用率。</p>
            `,

            `
            <p class="tit">  维护保养</p>
            <p> ● 智能化维护保养系统，提供自动提醒和维护记录。</p>
            <p> ● 减少设备停机时间，确保设备正常运行，降低维护成本。</p>
          
            `,

            `
            <p class="tit"> 统计分析</p>
            <p>  ● 提供数据统计和分析工具，帮助优化服务平台运营。</p>
            <p> ● 提供决策支持，提高运营效率，优化资源配置。</p>
            `,
        ],
    },
    {
        title: "行业定制化服务",
        index: 9,
        class: "item-f",
        img: [
            '33.png',
            '34.png',
            '35.png',
            '36.png',
        ],
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p  class="tit">  大模型技术</p>
            <p>  ● 基于行业需求提供大规模模型技术支持，优化业务流程。</p>
            <p>  ● 提高业务处理效率，提供智能化决策支持，增强竞争力。</p>
           
            `,

            `
         
            <p  class="tit">  视觉AI算法</p>
            <p>  ● 利用视觉AI算法进行图像和视频分析，提供智能化解决方案。</p>
            <p>  ● 提高图像处理和分析效率，应用范围广泛，提升服务质量。</p>
           
            `,

            `
           
            <p  class="tit">  能源智能优化</p>
            <p>  ● 根据行业特点提供能源优化解决方案，减少能源消耗。</p>
            <p>  ● 降低能源成本，提升能源利用效率，符合绿色发展理念。</p>
           
            `,
            `
         
            <p  class="tit">  智能机器人</p>
            <p> ● 提供智能机器人解决方案，优化生产和服务流程。</p>
            <p> ● 提高自动化水平，减少人工成本，提升生产和服务效率。</p>
            `,
        ],
    },

];

export default solutionList;
